
import ActualizacionDatosModel from "@/models/ActualizacionDatos/ActualizacionDatosModel";
import GlobalConfig from "@/GlobalConfig";
import ContactComponent from "@/components/Actualizacion_Datos/ContactComponent.vue";
import UmbracoApiService from "@/services/UmbracoApiService";
import { AxiosResponse } from "axios";
import { Component, Vue, Watch } from "vue-property-decorator";
import UserResponse from "@/models/WsdlResponses/UserResponse";
import WsdlService from "@/services/WsdlService";
import Swal from "sweetalert2";
import { formatFechaAfpSiembra } from "@/utils/HelperFunctions";
import User from "@/models/User";
import AfpUser, { AfpUserContact } from "@/models/AfpUser";
import { Getter } from "vuex-class";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import CityResponse from "@/models/WsdlResponses/CityResponse";
import ZoneResponse from "@/models/WsdlResponses/ZoneResponse";
import AfpUserServiceContact, { UserContact } from "@/models/AfpUserServiceContact";

@Component({
  components: {
      ContactComponent,
  },
})
export default class ActualizacionDatos extends Vue {
  @Getter("user") userGetter: User;
  public email: string = this.$store.state.user.correoElectronico1;
  public nombre: string = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
  public userId: string = this.$store.state.user.cedula;
  public user: UserResponse = new UserResponse();
  public afpUser: AfpUser = new AfpUser();
public contacts: Array<AfpUserContact> = [];
  public loadContacts: boolean = false;
public isProcessing: boolean = false;
  public checkProcesar: boolean = false;
  public cityHome: CityResponse = null;
  public cityWork: CityResponse = null;
  public zoneHome: ZoneResponse = null;
  public zoneWork: ZoneResponse = null;
  public cities: Array<Option<CityResponse>> = [];
  public zones: Array<Option<ZoneResponse>> = [];
  public wsdlService: WsdlService = new WsdlService();
  public isLoadingZone: boolean = false;
  public isLoadingCity: boolean = false;
  public umbracoService = new UmbracoApiService();
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public actualizacionDatos = new ActualizacionDatosModel();
  public contactsArray: Array<AfpUserContact> = [];
  @Getter("user") loggedInUser: User;

  async created() {
      await this.getData();
      await this.getUser(this.userId);
      await this.getUserContacts(this.userId);
      await this.getCities();
  }
  public async getUser(userId: string) {
      this.wsdlService.getUser(userId, this.loggedInUser.password).then((respone: AxiosResponse<any>) => {
          this.afpUser = respone.data;
      });
  }
  public getCities(city: string = "") {
      this.isLoadingCity = true;
      this.wsdlService
          .GetCiudades(city)
          .then((response: AxiosResponse<Array<CityResponse>>) => {
              this.cities = response.data.map((respObj: CityResponse) => ({
                  value: respObj,
                  text: respObj.descripcion,
                  disabled: false,
              }));
              this.isLoadingCity = false;
          });
  }
  public getZones(city: string, zone: string = "") {
      this.isLoadingZone = true;
      this.wsdlService
          .GetSectores(city, zone)
          .then((response: AxiosResponse<Array<ZoneResponse>>) => {
              this.zones = response.data.map((respObj: ZoneResponse) => ({
                  value: respObj,
                  text: respObj.descripcion,
                  disabled: false,
              }));
              this.isLoadingZone = false;
          });
  }
  public async getUserContacts(userId: string) 
{
      this.wsdlService
          .GetUserContacts(userId)
          .then((resp: AxiosResponse<any>) => {
              this.contacts = resp.data == null ? [] : resp.data;
              this.contactsArray = [...this.contacts];
              for (var i = this.contacts.length - 1; i < 4; i++) {
                  var emptyContact = new AfpUserContact();
                  this.contactsArray.push(emptyContact);
              }
              this.contacts[0].isExpanded = true;
          })
          .finally(() => {
              this.loadContacts = true;
          });
  }
  async getData() {
      this.actualizacionDatos =
          await this.umbracoService.getActualizacionDatos();
  }
  returnHome() {
      window.location.href = GlobalConfig.BASE_URL;
  }
  async process() {
      if (!this.checkProcesar) {
          Swal.fire({
              text: "Debe aceptar los teminos y condiciones para procesar su solicitud",
              icon: "info",
              showConfirmButton: true,
              confirmButtonText: "Ok",
          });
          return;
      }
  this.isProcessing = true
  await this.updateUser().then(async () => {
    
    await this.updateUserContacts()
  
  })
  .then(() => {
    this.$router.push("result-actualizacion-datos");
  })
  .catch(() => {
      Swal.fire({
        text: 'Ha ocurrido un error con la comunicación',
        icon: "error",
        showConfirmButton: true,
        confirmButtonText: "Ok",
      });
    })
    .finally(() => {this.isProcessing = false;});
  
  }
async updateUser(){
  console.log(this.afpUser);
  this.afpUser.cedula = this.userId;
  this.afpUser.codusuario = this.userId;
  if(this.afpUser.emailusuario!= null && this.afpUser.emailusuario != undefined){
    this.afpUser.emailusuario = this.afpUser.emailusuario.toLowerCase();
    this.afpUser.emailservidor = '@' + this.afpUser.emailusuario.split('@')[1];
  }
  await this.wsdlService
    .postActualizarInfoUsuario(this.afpUser)
    .then((resp) => {
      debugger;
    })
    .catch((err) => {
      console.error(err);
    });
}
async updateUserContacts(){
  let user = new AfpUserServiceContact();
  this.contactsArray.forEach(element => {
    user.contacts.push({
      idSec: element.idsec,
      cedula: element.cedulacontacto,
      parentesco: element.parentescocontacto,
      nombre: element.nombrecontacto,
      direccion: element.direccioncontacto,
      telefono: element.telefonocontacto,
      email: element.emailcontacto,
      menor: element.esmenor
    } as UserContact);
  });
  // user.cedula = this.afpUser.codusuario;
  user.cedula = this.userId;
  await this.wsdlService
  .postContactosUsuario(user)
  .catch((err) => {
      console.error(err);
    });;
}

  @Watch("city")
  public async onCityChange(value: CityResponse) {
      await this.getZones(value.ciudad);
  }
}
